<template>
  <!-- <Dialog v-model:visible="showDialog" :modal="true" :header="$t('subgroup.title')"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '40vw' }"> -->
  <Dialog
    :modal="true"
    v-model:visible="showDialog"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    :header="model ? $t('subgroup.Edittitle') : $t('subgroup.title')"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="6">
          <div class="field">
            <TextField
              :required-icon="true"
              id="code"
              name="code"
              :label="$t('subgroup.code')"
              :rules="{ required: true }"
              v-model="Subgroupform.Code"
              type="text"
              placeholder=" "
              disabled
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8">
          <div class="field">
            <TextField
              :required-icon="true"
              id="Item Subgroup Name"
              name="Item Subgroup Name"
              :label="$t('subgroup.name')"
              :rules="{ required: true }"
              v-model="Subgroupform.Name"
              type="text"
              placeholder=" "
              case="Capital"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <CustomDropdown
              :required-icon="true"
              :label="$t('subgroup.Mapping')"
              :rules="{ required: true }"
              id="Item Group Mapping"
              name="Item Group Mapping"
              v-model="Subgroupform.GroupId"
              :items="group.groupoption"
              :filter="true"
              :editable="false"
            />
            <!-- <span class="float-end blue-txt mt-3" @click="FunctionRights(EntityIds.SubCategory, 'SubCategory')">+ Add
              Item Group </span> -->
          </div>
          <span
            class="add_circle"
            @click="FunctionRights(EntityIds.SubCategory, 'SubCategory')"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <Footer
        @cancel="(showDialog = false), IsClear()"
        :cancelhide="false"
        :label="label"
        :loading="Saveloader"
      />
    </b-form>
  </Dialog>
  <GroupCreation
    v-if="DialogShow.SubCategory"
    @load="groupdropdownapi(), (DialogShow.SubCategory = false)"
    @close="DialogShow.SubCategory = false"
    @loaderhide="loading = false"
    @loadershow="loading = true"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.SubCategory"
  />

  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <EditConfirmation
    :Editmodel="Editmodel"
    @yes="IsEdit()"
    @no="Editmodel = false"
    :content="$t('confirmation.editcontent')"
  />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import SubgroupService from "../../../../../../modules/Inventory/Service/SubgroupService";
import GroupService from "../../../../../../modules/Inventory/Service/GroupService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import moment from "moment";
import GroupCreation from "../../../Masters/ItemCategory/GroupMaster/GroupCreation.vue";
import MastersService from "../../../../Service/MastersService";
import { checkPermission } from "../../../../Service/AccessControl";
import { useToast } from "primevue/usetoast";
export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
  },
  components: {
    AlreadyExist,
    CreateSuccessully,
    UpdatedSuccessfully,
    EditConfirmation,
    CustomDropdown,

    Footer,
    TextField,
    GroupCreation,
  },
  setup(props, { emit }) {
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    let loading = ref(false);
    let Saveloader = ref(false);
    const toast = useToast();
    //Session Hospital&Branch ID
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      SubCategory: false,
    });
    let EntityIds = ref({
      SubCategory: 107,
    });

    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        IsSubmit();
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      }
      // else if (event.altKey && event.key == 'n') {
      // showDialog.value = true;
      // }
      else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
      // else if (event.key == 'e') {
      // IsEdit()
      // }
      // else if (event.key == 'Escape') {

      // IsClear()
      // }
    }
    let items = ref([]);
    //update and create jsonrequest

    const Subgroupform = ref({
      Id: 0,
      Name: "",
      Code: "",
      GroupId: ref(),
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      EntityId: 0,
      EntityOperationId: 0,
    });

    async function IsEdit() {
      showDialog.value = true;
      emit("loadershow");
      try {
        label.value = "Update";
        let Id = model.value.Id;
        const response = await SubgroupService.getfindonedata(Id);
        let data = response["result"];
        Object.keys(Subgroupform.value).forEach((key) => {
          if (data[key]) Subgroupform.value[key] = data[key];
        });
        Editmodel.value = false;
        showDialog.value = false;
        emit("loaderhide");
        showDialog.value = true;
      } catch (error) {
        showDialog.value = false;
        emit("loaderhide");
        alert(error);
      }
    }
    //Submit Function
    const IsSubmit = async () => {
      emit("loadershow");
      Saveloader.value = true;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      try {
        Subgroupform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        Subgroupform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        Subgroupform.value.BranchId = BranchId;
        Subgroupform.value.HospitalId = HospitalId;
        Subgroupform.value.ModifiedBy = UserId;
        Subgroupform.value.CreatedBy = UserId;
        Subgroupform.value.EntityId = Number(Entitydata.value.EntityId);

        if (Subgroupform.value.Id != 0) {
          Subgroupform.value.EntityOperationId = props.OperationID.UpdateId;
          const response = await SubgroupService.updatedata(Subgroupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (response["result"] == "Already" && message == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloader.value = false;
            updatepop.value = true;
          }
        } else {
          Subgroupform.value.EntityOperationId = props.OperationID.CreateId;
          const response = await SubgroupService.createdata(Subgroupform.value);
          console.log(Subgroupform.value);
          let message = response["ErrorInfo"].ErrorCode;
          emit("loaderhide");
          if (response["result"] == "Already" && message == null) {
            Saveloader.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloader.value = false;
            successpop.value = true;
          }
        }
      } catch (error) {
        emit("loaderhide");
        alert(error);
        Saveloader.value = false;
      }
    };
    const copydataModel = JSON.parse(JSON.stringify(Subgroupform.value));
    const copyselectOption = JSON.parse(JSON.stringify(items.value));

    const IsClear = () => {
      Object.assign(Subgroupform.value, copydataModel);
      Object.assign(items.value, copyselectOption);
      emit("update:selectedItem", undefined);
      emit("close");
      console.log(Subgroupform.value);
    };

    //Group dropdown
    const group = ref({
      groupoption: [],
    });
    async function groupdropdownapi() {
      debugger;
      try {
        debugger;
        const response = await GroupService.getdata();
        items.value = response["result"].reverse();
        console.log(items.value);
        group.value.groupoption = response["result"]
          .filter(
            (items) => items.HospitalId == HospitalId && items.Status == true
          )
          .map((item) => {
            item.name = item.CategoryName + " - " + item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        alert(error);
      }
    }

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 24,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      Subgroupform.value.Code = result;
      if (result) {
        showDialog.value = true;
      }
    }
    async function IsEditpop() {
      Editmodel.value = true;
    }
    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }
    const alreadyexistpop = ref(false);
    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      Subgroupform.value.Name = ""; //showDialog.value = true
    }

    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    return {
      Saveloader,
      loading,
      ObjOperationId,
      FunctionRights,
      EntityIds,
      DialogShow,
      alreadyclosetrigger,
      alreadyexistpop,
      IsEditpop,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsCreate,
      showDialog,
      IsClear,
      IsEdit,
      groupdropdownapi,
      group,
      Subgroupform,
      IsSubmit,
      GetCode,
      label,
      model,
    };
  },
  created() {
    this.groupdropdownapi();
  },
});
</script>
